import { ErrorLayout } from '../../components/Errors/ErrorLayout';
import { ErrorImage } from '../../components/Errors/ErrorImage';
import { ErrorContent } from '../../components/Errors/ErrorContent';
import notFound from '../../assets/images/not-found.png';
import { memo } from 'react';
import { t } from 'i18next';

type Error404Props = {
  errorText: string;
  className?: string;
};

const Error404 = ({ errorText = t('404 - URL does not exist'), className }: Error404Props) => {
  return (
    <ErrorLayout className={className}>
      <ErrorImage src={notFound} alt="Page not found" />
      <ErrorContent title={errorText} />
    </ErrorLayout>
  );
};

export default memo(Error404);
